













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import DialogoDeEdicaoDeFornecedor from '@/components/fornecedor/DialogoDeEdicaoDeFornecedor.vue'
import BuscaDeProdutoDropdown from '@/components/produto/BuscaDeProdutoDropdown.vue'
import { ImportacaoDeNota, ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import { fixarCasasDecimais, formatarCnpjOuCpf, formatarMoeda } from '@/shareds/formatadores'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase, FindAtributoUseCase, FindGradeDeProdutosUseCase, ImportarNotaDoFornecedorUseCase, FindProdutoUseCase, SaveProdutoUseCase, FindImportacaoUseCase } from '@/usecases'
import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import ProdutoDaImportacaoDeNota from "./ProdutoDaImportacaoDeNota.vue"
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import { AtributoDoProduto, Marca, Produto, ProdutoComVariantes, Variacao, Variante } from '@/models'
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeCategoria from '../produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue'
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import DialogoDeSelecaoDeGradeDeProdutos from '@/components/produto/DialogoDeSelecaoDeGradeDeProdutos.vue'
import cartesianProduct from 'cartesian-product'
import SeletorDeNcm from '@/components/ui/SeletorDeNcm.vue'
import SeletorDeUnidadeDeMedida from '@/components/produto/SeletorDeUnidadeDeMedida.vue'
import DialogoDeAdicionarCor from '@/components/produto/DialogoDeAdicionarCor.vue'
import DialogoDeRelacaoDeProdutosPaiParaEntradaDaNota from './DialogoDeRelacaoDeProdutosPaiParaEntradaDaNota.vue'
import DialogoDeDetalharProdutosDaImportacao from './DialogoDeDetalharProdutosDaImportacao.vue'
import DialogoDeBuscarVinculoDeProdutos from './DialogoDeBuscarVinculoDeProdutos.vue'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import DialogoDeAgruparItensDaImportacao from './DialogoDeAgruparItensDaImportacao.vue'
import DialogoDeRelacaoDeVariantesParaEntradaDaNota from './DialogoDeRelacaoDeVariantesParaEntradaDaNota.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
const IMPORTACAO_DE_NOTA = 'IMPORTACAO_DE_NOTA'
const VARIANTE_DA_IMPORTACAO = 'VARIANTE_DA_IMPORTACAO'

@Component({
	components: {
		BuscaDeProdutoDropdown,
		DialogoDeSelecaoDeGradeDeProdutos,
		DialogoDeEdicaoDeFornecedor,
		ProdutoDaImportacaoDeNota,
		SeletorDeMarca,
		SeletorDeTag,
		SeletorDeCategoria,
		SeletorDeEstacao,
		SeletorDeGenero,
		CampoDePercentual,
		Confirmacao,
		SeletorDeNcm,
		SeletorDeUnidadeDeMedida,
		DialogoDeAdicionarCor,
		DialogoDeRelacaoDeVariantesParaEntradaDaNota,
		DialogoDeRelacaoDeProdutosPaiParaEntradaDaNota,
		DialogoDeDetalharProdutosDaImportacao,
		DialogoDeBuscarVinculoDeProdutos,
		DialogoDeAgruparItensDaImportacao,
		CampoDecimal,
	},
})
export default class TelaDeImportacaoDeNota extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() dialogoDeFornecedor!: DialogoDeEdicaoDeFornecedor
	@Ref() dialogoDeSelecaoDeGradeDeProdutos!: DialogoDeSelecaoDeGradeDeProdutos
	@Ref() dialogoDeAdicionarCor!: DialogoDeAdicionarCor
	@Ref() confirmarAlteracaoDaMargemDeLucro!: Confirmacao
	@Ref() confirmarAlteracaoDasMarcas!: Confirmacao
	@Ref() campoDeMargemDeLucro!: CampoDecimal
	@Ref() confirmacaoDeNotaPorItemPai!: Confirmacao
	@Ref() dialogoDeRelacaoDeVariantesParaEntradaDaNota!: DialogoDeRelacaoDeVariantesParaEntradaDaNota
	@Ref() dialogoDeRelacaoDeProdutosPaiParaEntradaDaNota!: DialogoDeRelacaoDeProdutosPaiParaEntradaDaNota
	@Ref() dialogoDeDetalharProdutosDaImportacao!: DialogoDeDetalharProdutosDaImportacao
	@Ref() confirmacaoDeDesvincularProduto!: Confirmacao
	@Ref() dialogoDeBuscarVinculoDeProdutos!: DialogoDeBuscarVinculoDeProdutos
	@Ref() dialogoDeAgruparItensDaImportacao!: DialogoDeAgruparItensDaImportacao
	@Ref() confirmacaoDeVincularVariantes!: Confirmacao
	@Ref() confirmacaoDeUtilizarDadosDaNota!: Confirmacao
	@Ref() confirmacaoDeReplicarAtributos!: Confirmacao

	AlertModule = AlertModule

	importarNotaDoFornecedorUseCase = new ImportarNotaDoFornecedorUseCase()
	finalizarImportacaoDeNotaDoFornecedorUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase()
	findGradeDeProdutosUseCase = new FindGradeDeProdutosUseCase()
	findAtributosUseCase = new FindAtributoUseCase()
    consultarProdutoUseCase = new (require('@/usecases/venda/ConsultarProdutoUseCase').ConsultarProdutoUseCase)()
	findImportacaoUseCase = new FindImportacaoUseCase()
	findSkusUseCase = new FindProdutoUseCase()
	saveProdutoUseCase = new SaveProdutoUseCase()

	formatarCnpjOuCpf = formatarCnpjOuCpf
	obrigatorio = obrigatorio
	fixarCasasDecimais = fixarCasasDecimais
	formatarMoeda = formatarMoeda
	file: File | null = null
	carregando = false
	criandoFornecedor = false
	enviando = false
	salvandoEdicaoDeProduto = false
	margemArredondamentoAcima = 0.99
	margemArredondamentoAbaixo = 0.00
	importacaoDeNota: ImportacaoDeNota | null = localStorage[IMPORTACAO_DE_NOTA]
		? JSON.parse(localStorage[IMPORTACAO_DE_NOTA])
		: null
	mostrarDialogoDeEdicaoDeProduto = false
	produtoEmEdicao: Produto = {} as Produto
	indiceEmEdicao = 0
	margemDeLucroGeral = 0
	naoDeveMovimentarEstoque = false
	naoDeveAtualizarTabelaDePreco = false
	naoUtilizarArredondamentoDecimal = false
	gerandoVariantes = false
	podeFinalizar = false
	carregandoVinculoDeProduto: Record<number, boolean> = {}
	carregandoPrecoPorIndice: Record<number, boolean> = {}
	precoPorProdutoId: Record<string, number> = {}
	produtosOriginal: ProdutoDaImportacao[] = []
	tableRerenderKey = 0
	produtoVazio: Produto[] = []
	produtosQueForamAgrupados: ProdutoDaImportacao[] = []
	produtosOriginaisDaNota: ProdutoDaImportacao[] = []
	criouReferenciaDeProdutoPaiNaImportacao = false
	variantesDaImportacao: Variante[] | null = localStorage[VARIANTE_DA_IMPORTACAO]
		? JSON.parse(localStorage[VARIANTE_DA_IMPORTACAO])
		: null
	mostrarDialogoDeVincularVariantes = false
	isDraggingOverNota = false
	isDraggingOverGrade = false
	hoveredVariante: any = null
	varianteSendoArrastada: any = null
	vinculacoes: Array<{ varianteNota: any; varianteGrade: any }> = []
	variantesDaNotaParaVincular: Variante[] = []
	varianteSelecionadaParaClique: Variante[] = []
	varianteGradeSelecionada: Variante[] = []
	modoSelecaoPorClique = false
	dialogoDeResumoDaNota = false
	cancelandoImportacaoDeNota = false;

	headersComCriacaoDeProduto = [
		{ text: '', value: 'alert', sortable: false },
		{ text: 'Nome', value: 'nota.xProd', width: '120px', sortable: false },
		{ text: '', value: 'contemAgrupamentoDeItens', sortable: false },
		{ text: 'Marca', value: 'encontrado.marca.nome', sortable: false },
		{ text: 'Cod. do fornecedor', value: 'nota.cProd', width: '200px', sortable: false },
		{ text: 'Quantidade', value: 'nota.qCom', sortable: false },
		{ text: 'Valor un.', value: 'nota.vUnCom', sortable: false },
		{ text: 'Margem de lucro', value: 'margemDeLucro', width: '95px', sortable: false },
		{ text: 'Preço de venda varejo', value: 'item.precoFinalVarejo', width: '95px', sortable: false },
		{ text: 'Ações', value: 'actions', sortable: false, align: 'center', cellClass: 'acoes-coluna' },
	]

	headersSemCriacaoDeProduto = [
		{ text: '', value: 'alert', sortable: false },
		{ text: 'Nome', value: 'nota.xProd', width: '120px', sortable: false },
		{ text: '', value: 'contemAgrupamentoDeItens', sortable: false },
		{ text: 'Marca', value: 'encontrado.marca.nome', sortable: false },
		{ text: 'Cod. do fornecedor', value: 'nota.cProd', width: '200px', sortable: false },
		{ text: 'Quantidade', value: 'nota.qCom', sortable: false },
		{ text: 'Valor un.', value: 'nota.vUnCom', sortable: false },
		{ text: 'Margem de lucro', value: 'margemDeLucro', width: '95px', sortable: false },
		{ text: 'Ações', value: 'actions', sortable: false, align: 'center', cellClass: 'acoes-coluna' },
	]

	headers = [
		{ text: 'Nome', value: 'nota.xProd', sortable: false },
		{ text: 'Quantidade', value: 'nota.qCom', sortable: false },
		{ text: 'Cód Fornecedor', value: 'nota.cProd', sortable: false },
		{ text: 'EAN', value: 'nota.cEAN',sortable: false },
	]

	get podeCriarProduto() {
		return (this.importacaoDeNota && this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja &&
			this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
	}

	get editandoProdutoJaCadastrado() {
		return this.produtoEmEdicao && 
			!!this.produtoEmEdicao.id && 
			(!this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === this.produtoEmEdicao.sku)?.isProdutoComReferenciaCriadaNaImportacao && 
				(this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === this.produtoEmEdicao.sku)?.encontrado?.id || 
					this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === this.produtoEmEdicao.sku)?.encontrado?.descricao === 'Produto Criado na Importação') || 
					this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === this.produtoEmEdicao.sku) === undefined)
	}

	verificaSeCriaProduto(item: ProdutoDaImportacao, importacaoDeNota) {
		return (
			(item.encontrado && item.encontrado.id) 
			|| importacaoDeNota 
			&& (importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja && !importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada)
		) && item.encontrado && item.encontrado.tipo !== 'Com Variantes'
	}

	quantidadesInformadasValidas() {
		if (!this.importacaoDeNota) return true
		if (this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').length === 0) return true

		const quantidadeInformadaTotal = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').map(produto => produto.quantidadeInformada||0).reduce((total, valor) => total + valor)
		const quantidadeEsperadaTotal = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo === 'Com Variantes').map(produto => parseInt(produto.nota.qCom)||0).reduce((total, valor) => total + valor)
		return quantidadeInformadaTotal === quantidadeEsperadaTotal
	}
	
	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async importarNota() {
		try {
			this.carregando = true
			
			if(!this.usuario) return

			if(!this.permiteAbrirDiversosProcessosDeImportacao){
				const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

				if(!possuiProcessoEmAberto){
					AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
					this.carregando = false;
					return
				}
			}

			this.importacaoDeNota = await this.importarNotaDoFornecedorUseCase.execute(
				this.file,
				(fornecedor) => this.dialogoDeFornecedor.mostrar(fornecedor, true),
			)

			if(!this.importacaoDeNota.produtos){
				AlertModule.setError('Não foi possivel encontrar informações sobre o produto!')
			}

			if(this.importacaoDeNota.fornecedor.encontrado && this.importacaoDeNota.fornecedor.encontrado.markup > 0){
				this.margemDeLucroGeral = this.importacaoDeNota.fornecedor.encontrado.markup
			}

			this.importacaoDeNota.produtos.forEach(produto => {
				if (produto.encontrado && (!produto.encontrado.id || !produto.isProdutoComReferenciaCriadaNaImportacao) && this.importacaoDeNota) {
					produto.encontrado.marca = this.importacaoDeNota.fornecedor.encontrado?.marca ?? produto.encontrado.marca
				}
			})

			this.importacaoDeNota.produtos.forEach(produto => {
				if (produto.encontrado && produto.encontrado.tipo === 'Com Variantes') {

					if(produto.encontrado.variantes.length === 0){
						produto.encontrado.variantes.sort((varianteA, varianteB) =>
							this.obterValorDoAtributo(varianteA, 'Tamanho').localeCompare(this.obterValorDoAtributo(varianteB, 'Tamanho')),
						)

						produto.encontrado.variantes.sort((varianteA, varianteB) =>
							this.obterValorDoAtributo(varianteA, 'Cor').localeCompare(this.obterValorDoAtributo(varianteB, 'Cor')),
						)
					}else {
						produto.encontrado.variantes.sort((varianteA, varianteB) =>
							this.obterValorDoAtributo(varianteA, 'Tamanho').localeCompare(this.obterValorDoAtributo(varianteB, 'Tamanho')),
						)

						produto.encontrado.variantes.sort((varianteA, varianteB) =>
							this.obterValorDoAtributo(varianteA, 'Cor').localeCompare(this.obterValorDoAtributo(varianteB, 'Cor')),
						)
					}
					
				}
			})

			this.importacaoDeNota.produtos.sort((produtoA, produtoB) => produtoA.nota.nItem - produtoB.nota.nItem)
			this.importacaoDeNota.isNecessarioDetalharOsItens = !!(await this.confirmacaoDeNotaPorItemPai.mostrar());

			if(this.importacaoDeNota.isNecessarioDetalharOsItens){
				this.dialogoDeRelacaoDeVariantesParaEntradaDaNota.mostrarDialogo(this.importacaoDeNota);
			}else{
				this.importacaoDeNota.produtos.forEach(p => {
					p.encontrado = null

					this.fazerVinculoDosProdutos(p.nota.cProd, p.indice)
				});
			}

			this.importacaoDeNota?.produtos.forEach(produto => {
				if(produto.nota.xProd.length > 60){
					produto.isProdutoPossuiNomeLongo = true
					produto.isNomeECodigoConfirmados = false
					produto.erroNomeDeProdutoEhLongo = 'Nome excede 60 caracteres'
				}
			})

			const todosCProds: string[] = [];

			this.importacaoDeNota.produtos.forEach(produto => {
				const cProd = produto.nota.cProd;

				if (cProd && cProd.trim() !== '') {
					todosCProds.push(cProd.trim());
				}
			});

			const contagemCProds: Record<string, number> = {};

			todosCProds.forEach(cProd => {
				contagemCProds[cProd] = (contagemCProds[cProd] || 0) + 1;
			});

			const cProdsDuplicados = new Set(
				Object.entries(contagemCProds)
					.filter(([, count]) => count > 1)
					.map(([cProd]) => cProd),
			);

			this.importacaoDeNota.produtos.forEach(produto => {
				const cProd = produto.nota.cProd;
				if (cProd && cProdsDuplicados.has(cProd.trim()) && this.importacaoDeNota && !this.importacaoDeNota.isNecessarioDetalharOsItens) {
					produto.isPossuiCProdDuplicado = true;
				} else {
					produto.isPossuiCProdDuplicado = false;
				}

				produto.contemAgrupamentoDeItens = false;
				produto.produtosAgrupados = []
			});

			this.produtosOriginal = this.importacaoDeNota.produtos
			
			if (this.produtosOriginal) {
				for (let i = 0;i < this.produtosOriginal.length; i++) {
					this.produtosOriginal[i].indice = i

					if (this.produtosOriginal[i].isCamposBloqueados === undefined) {
						this.produtosOriginal[i].isCamposBloqueados = false
					}

					if (this.produtosOriginal[i].isNomeECodigoConfirmados === undefined) {
						this.produtosOriginal[i].isNomeECodigoConfirmados = false
					}
				}
			}

			this.importacaoDeNota.produtos.forEach(produto => {
				produto.encontrado && produto.encontrado.id ?
					produto.criouRelacaoDeProdutoPai = true :
					produto.criouRelacaoDeProdutoPai = false

				produto.nota.vUnCom = formatarMoeda(Number(produto.nota.vUnCom))
				this.modificarMargemDeLucro(produto)	
			})

			if(this.importacaoDeNota && !this.importacaoDeNota.isNecessarioDetalharOsItens){
				this.mostrarConfimacao()
			}

		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
			this.importacaoDeNota?.produtos.forEach(item => {
				if(item.quantidadeInformada !== Number(item.nota.qCom)){
					this.alternarBloqueioCampos(item)
				}

				this.itensPendentes
			})
		}
	}

	created() {
		if (this.importacaoDeNota) {
			for (let i = 0;i < this.importacaoDeNota.produtos.length; i++) {
				this.importacaoDeNota.produtos[i].indice = i

				if (this.importacaoDeNota.produtos[i].isCamposBloqueados === undefined) {
					this.importacaoDeNota.produtos[i].isCamposBloqueados = false
				}

				if (this.importacaoDeNota.produtos[i].isNomeECodigoConfirmados === undefined) {
					this.importacaoDeNota.produtos[i].isNomeECodigoConfirmados = false
				}
			}
		}
		this.validarNomeDeProduto()
	}

	get tiposDeProdutos(): BuscaDeProdutoDropdown['filtros'] {
		return { tipos: ['Padrão', 'Variante', 'Composto'] }
	}

	async iniciarProcessoDeFinalizacaoDaNota(){
		if (!this.importacaoDeNota) return;
		if (this.importacaoDeNota.produtos.some(({ encontrado }) => !encontrado)) {
			AlertModule.setError('Existem produtos não associados');
			return;
		}
		if (!this.form.validate()) return;

		if (this.importacaoDeNota) {
			const itensSemGrade = this.importacaoDeNota.produtos
				.filter(p => p && p.encontrado && p.encontrado.tipo === 'Padrão' && !this.possuiAtributosDeProduto(p.encontrado) && !p.isProdutoEstaAgrupado)
				.map(p => `Item ${p.nota.nItem} - ${p.nota.cProd}`);

			if (itensSemGrade.length > 0) {
				return AlertModule.setError(`Há produto(s) padrão sem grade selecionada:\n${itensSemGrade.join('\n')}`)
			}
		}

		if (this.importacaoDeNota.produtos.some(p => p.encontrado?.descricao === 'Produto Criado na Importação')) {
			this.importacaoDeNota.produtos.forEach(p => {
				if (p.encontrado?.descricao === 'Produto Criado na Importação') {
					p.encontrado.descricao = '';
				}
			});
		}

		if (!this.validarSkusDuplicadosNaImportacao()) return

		try {
			this.enviando = true;

			this.importacaoDeNota.naoDeveAtualizarTabelaDePreco = this.naoDeveAtualizarTabelaDePreco
			this.importacaoDeNota.naoDeveMovimentarEstoque = this.naoDeveMovimentarEstoque

			const importacaoDeNotaBlob = new Blob([JSON.stringify(this.importacaoDeNota)], { type: 'application/json' });
			const importacaoDeNotaFile = new File([importacaoDeNotaBlob], 'importacaoDeNota.json', { type: 'application/json' });

			const informacoesDosArquivos = await uploadFilesToS3([importacaoDeNotaFile], 'importacao-de-notas');
			const urlDoArquivoJson = informacoesDosArquivos.map(({ config }) => config.url)[0];

			if (!urlDoArquivoJson) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte");
			}

			const importacaoDeNotaFinalizada = await this.finalizarImportacaoDeNotaDoFornecedorUseCase.execute(urlDoArquivoJson, this.naoDeveMovimentarEstoque, this.naoDeveAtualizarTabelaDePreco);

			if (!importacaoDeNotaFinalizada.feedbackDosTitulos) {
				AlertModule.setSuccess('Processo de nota iniciado com sucesso!');
			} else {
				AlertModule.setInfo(`Processo de nota iniciado com sucesso, porém ${importacaoDeNotaFinalizada.feedbackDosTitulos}`);
			}

		} catch (error: any) {
			AlertModule.setError(error);
			return;
		} finally {
			this.enviando = false;
			this.limparIntegracaoDeNota()
			this.dialogoDeResumoDaNota = false
		}
	}

	async salvarMapeamentoDeNotas() {
		if(!this.importacaoDeNota) return

		if((this.importacaoDeNota.produtos.filter(p => p.isCamposBloqueados).length === 0)){
			AlertModule.setError('Necessario confirmar ao menos 1 item!')
			return
		}
 
		this.dialogoDeResumoDaNota = true;
	}

	abrirDialogoDeDetalhesDoProduto(item: ProdutoDaImportacao) {
		this.dialogoDeDetalharProdutosDaImportacao.mostrar(item)
	}

	async cancelarIntegracaoDeNota() {
		try{
			this.cancelandoImportacaoDeNota = true;
			const produtosIncompletos =
			this.importacaoDeNota?.produtos
				.filter(p => p.encontrado?.tipo === 'Com Variantes' && p.encontrado.produtoIncompleto === true)
				.map(p => p.encontrado)
				.filter((p): p is Produto => p !== null && p !== undefined) || [];

			if (produtosIncompletos.length > 0) {
				await this.saveProdutoUseCase.deleteProdutoIncompleto(produtosIncompletos);
			}
		} catch(error) {
			AlertModule.setError(error)
			this.cancelandoImportacaoDeNota = false;
		} finally {
			this.limparIntegracaoDeNota()
			this.cancelandoImportacaoDeNota = false;
		}
	}

	validarSkusDuplicadosNaImportacao(): boolean {
		if (!this.importacaoDeNota) return true

		const mapaDeSkus: { [sku: string]: boolean } = {}
		const skusDuplicados: string[] = []

		const registrarSku = (sku?: string | null) => {
			if (!sku) return

			if (mapaDeSkus[sku]) {
				if (!skusDuplicados.includes(sku)) {
					skusDuplicados.push(sku)
				}
			} else {
				mapaDeSkus[sku] = true
			}
		}

		this.importacaoDeNota.produtos.forEach(produto => {
			if (!produto.encontrado) return

			registrarSku(produto.encontrado.sku)

			if (produto.encontrado.tipo === 'Com Variantes' && produto.encontrado.variantes) {
				produto.encontrado.variantes.forEach(variante => registrarSku(variante.sku))
			}
		})

		if (skusDuplicados.length > 0) {
			AlertModule.setError(`Os SKUs ${skusDuplicados.join(', ')} já existem em outro produto na importação atual`)
			return false
		}

		return true
	}

	limparIntegracaoDeNota() {
		localStorage.removeItem(IMPORTACAO_DE_NOTA)
		localStorage.removeItem(VARIANTE_DA_IMPORTACAO)
		this.importacaoDeNota = null
		this.variantesDaImportacao = null
		this.variantesDaNotaParaVincular = []
		this.variantesDaImportacao = []
	}

	async editarFornecedor() {
		if (!this.importacaoDeNota || !this.importacaoDeNota.fornecedor.encontrado) return
		const fornecedor = await this.dialogoDeFornecedor.mostrar(this.importacaoDeNota.fornecedor.encontrado, false)
		if (!fornecedor) return
		this.importacaoDeNota = {
			...this.importacaoDeNota,
			fornecedor: {
				...this.importacaoDeNota.fornecedor,
				encontrado: fornecedor,
			},
		}
	}

	@Watch('importacaoDeNota', { deep: true, immediate: true })
	onChangeIntegracaoDeNota() {
		if (this.importacaoDeNota) {
			this.importacaoDeNota.produtos.forEach(produto => {
				if (produto.encontrado && produto.encontrado.tipo === 'Com Variantes') {
					produto.quantidadeInformada = produto.encontrado.variantes ? produto.encontrado.variantes.map(variante => variante.quantidadeImportacao||0).reduce((total, valor) => total + valor) : 0
				} else {
					produto.quantidadeInformada = 0
				}

				if (typeof produto.indice === 'number' && this.carregandoVinculoDeProduto[produto.indice] === undefined) {
					this.$set(this.carregandoVinculoDeProduto, produto.indice, false)
				}
				if (typeof produto.indice === 'number' && this.carregandoPrecoPorIndice[produto.indice] === undefined) {
					this.$set(this.carregandoPrecoPorIndice, produto.indice, false)
				}
			})

			this.importacaoDeNota.quantidadesPreenchidasCorretamente = this.quantidadesInformadasValidas()
			this.onReloadFinalizar()
		}

		this.file = null
		localStorage.setItem(IMPORTACAO_DE_NOTA, JSON.stringify(this.importacaoDeNota))
		localStorage.setItem(VARIANTE_DA_IMPORTACAO, JSON.stringify(this.variantesDaImportacao))
	}

	@Watch('importacaoDeNota.produtos', { deep: true })
	onProdutosArrayChange() {
		if (!this.importacaoDeNota) return
		
		this.importacaoDeNota.produtos.forEach((produto, index) => {
			produto.indice = index
		})
	}

	async abrirDialogoDeEditarProduto(produto: ProdutoDaImportacao, indiceEmEdicao: number) {
		this.indiceEmEdicao = indiceEmEdicao
		if(!produto.encontrado) {
			this.produtoEmEdicao.tipo = 'Com Variantes'
			if(!this.produtoEmEdicao.nome){
				this.produtoEmEdicao.nome = produto.nota.xProd
			}

			if(!this.produtoEmEdicao.sku){
				this.produtoEmEdicao.sku = produto.nota.cProd
			}

			if(!this.produtoEmEdicao.unidadeDeMedida){
				this.produtoEmEdicao.unidadeDeMedida = produto.nota.uCom
			}
			
			if(!this.produtoEmEdicao.precoCompra){
				this.produtoEmEdicao.precoCompra = Number(produto.nota.vUnCom.replace(',', '.'))
			}

			if (!this.produtoEmEdicao.ncm) {
				this.produtoEmEdicao.ncm = { codigo: produto.nota.NCM, descricao: '' }
			}

			this.mostrarDialogoDeEdicaoDeProduto = true	
			return
		}

		this.criouReferenciaDeProdutoPaiNaImportacao = produto.isProdutoComReferenciaCriadaNaImportacao;

		this.produtoEmEdicao = JSON.parse(JSON.stringify(produto.encontrado))

		if (!produto.encontrado.precoCompra) {
			produto.encontrado.precoCompra = produto.encontrado.preco
			produto.encontrado.margemLucro = 0
		}

		this.produtoEmEdicao.margemLucro = produto.margemDeLucro
		this.produtoEmEdicao.precoCompra = produto.precoFinalVarejo
		this.produtoEmEdicao.unidadeDeMedida = produto.encontrado.unidadeDeMedida
		this.produtoEmEdicao.unidadeDeConversao = produto.encontrado.unidadeDeConversao
		this.produtoEmEdicao.ncm = {
			id: '',
			descricao: '',
			codigo: produto.nota.NCM,
		}

		this.produtoEmEdicao.skuPai = produto.encontrado.skuPai

		if(!produto.encontrado.id || !produto.isProdutoComReferenciaCriadaNaImportacao){
			if(!this.produtoEmEdicao.nome){
				this.produtoEmEdicao.nome = produto.nota.xProd
			}

			if(!this.produtoEmEdicao.sku){
				this.produtoEmEdicao.sku = produto.nota.cProd
			}

			if(!this.produtoEmEdicao.unidadeDeMedida){
				this.produtoEmEdicao.unidadeDeMedida = produto.nota.uCom
			}
			
			if(!this.produtoEmEdicao.preco){
				this.produtoEmEdicao.preco = Number(produto.nota.vUnCom)
			}
			
			this.produtoEmEdicao.eans = []
		}

		this.mostrarDialogoDeEdicaoDeProduto = true
	}

	async salvarProduto() {
		this.salvandoEdicaoDeProduto = true
		if (!this.importacaoDeNota) {
			this.salvandoEdicaoDeProduto = false
			return
		}

		if ((!this.produtoEmEdicao.unidadeDeMedida || this.produtoEmEdicao.unidadeDeMedida === '')) {
			this.produtoEmEdicao.unidadeDeMedida = 'UNID'
		}

		if(this.produtoEmEdicao && this.produtoEmEdicao.tipo === 'Com Variantes' && this.produtoEmEdicao.ncm && this.produtoEmEdicao.variantes){
			this.produtoEmEdicao.variantes.forEach(variante => {
				variante.ncm = this.produtoEmEdicao.ncm
				variante.preco = this.produtoEmEdicao.preco
				variante.precoCompra = this.produtoEmEdicao.precoCompra
				variante.unidadeDeMedida = this.produtoEmEdicao.unidadeDeMedida
			})
		}

		if (this.indiceEmEdicao >= 0 && this.indiceEmEdicao < this.importacaoDeNota.produtos.length) {
			const produtoNoArray = this.importacaoDeNota.produtos[this.indiceEmEdicao]
			
			if (produtoNoArray && produtoNoArray.nota) {
				produtoNoArray.nota.cProd = this.produtoEmEdicao.skuPai || this.produtoEmEdicao.sku || produtoNoArray.nota.cProd
				produtoNoArray.nota.xProd = this.produtoEmEdicao.nome
				produtoNoArray.encontrado = JSON.parse(JSON.stringify(this.produtoEmEdicao))
				produtoNoArray.margemDeLucro = this.produtoEmEdicao.margemLucro || 0
				
				if(produtoNoArray.encontrado?.tipo === 'Com Variantes' && this.produtoEmEdicao.tipo === 'Com Variantes' && produtoNoArray.encontrado.variantes){
					produtoNoArray.encontrado.variantes = this.produtoEmEdicao.variantes
				}

				const qtdeDeProdutosComOhMesmoCodigo = this.importacaoDeNota.produtos
					.filter((p, idx) => p && p.nota && p.nota.cProd === (this.produtoEmEdicao.skuPai || this.produtoEmEdicao.sku) && idx !== this.indiceEmEdicao)
					.length

				if (qtdeDeProdutosComOhMesmoCodigo > 0) {
					AlertModule.setError('Código já cadastrado em outros produtos, favor validar!')
					this.salvandoEdicaoDeProduto = false
					return
				}

				this.$set(this.importacaoDeNota.produtos, this.indiceEmEdicao, { ...produtoNoArray })
				
				localStorage.setItem(IMPORTACAO_DE_NOTA, JSON.stringify(this.importacaoDeNota))
			}
		}

		this.criouReferenciaDeProdutoPaiNaImportacao = false

		if(this.variantesDaImportacao === null){
			this.validarCProdDuplicados()
		}

		if(this.produtoEmEdicao.tipo === 'Com Variantes' && this.produtoEmEdicao.variantes){
			this.produtoEmEdicao.variantes.forEach(variante => {
				this.ajustarQuantidade(variante, this.importacaoDeNota?.produtos[this.indiceEmEdicao], this.produtoEmEdicao.tipo === 'Com Variantes' ? this.produtoEmEdicao.variantes : null);
			})
		}

		this.fecharDialogoDeEdicaoDeProduto()
		this.salvandoEdicaoDeProduto = false
	}

	fecharDialogoDeEdicaoDeProduto() {
		this.produtoEmEdicao = {} as Produto
		this.indiceEmEdicao = 0
		this.mostrarDialogoDeEdicaoDeProduto = false
		this.criouReferenciaDeProdutoPaiNaImportacao = false
	}

	calculaPrecoVarejo() {
		if (!this.produtoEmEdicao) return

		const precoCompra = Number(this.produtoEmEdicao.precoCompra) || 0
		const margemDeLucro = 1 + (Number(this.produtoEmEdicao.margemLucro) || 0) / 100

		const precoBruto = precoCompra * margemDeLucro
		const precoComDuas = Math.round(precoBruto * 100) / 100

		this.produtoEmEdicao.preco = this.arredondarPreco(precoComDuas)
	}

	@Watch('importacaoDeNota.produtos', { deep: true })
	onProdutosChange() {
		this.importacaoDeNota?.produtos.forEach(produto => {
			if (produto.precoFinalVarejo && !produto.isCamposBloqueados) {
				const precoAtual = parseFloat(String(produto.precoFinalVarejo));
				if (!isNaN(precoAtual)) {
					produto.precoFinalVarejo = this.arredondarPreco(precoAtual);
				}
			}
		});
	}

	formatarMenssagem() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					A margem de lucro do seu fornecedor é de ${this.margemDeLucroGeral}%
					Deseja aplicar para todos os itens?
				</div>
			`
	}

	formatarMenssagemDasMarcas() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, todos os produtos desta nota serão associados a esta marca
				</div>
			`
	}

	formatarMensagemDeImportacaoDeNota() {
		return `
			<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Fechada: a nota será considerada como fechada pelo produto principal.
				</div>
			</div>
			`
	}

	formatarMensagemDeImportacaoDeNotaSecundario() {
		return `
				<div class="mt-4">
					Aberta: a nota será considerada como aberta por grade (tamanho e/ou cor)
				</div>
			`
	}

	async mostrarConfimacao() {
		if(!this.importacaoDeNota) return
		if(this.margemDeLucroGeral && this.margemDeLucroGeral > 0){
			if(!await this.confirmarAlteracaoDaMargemDeLucro.mostrar()) return
		}
		
		this.inserirMargemDeLucroNosItens()
	}

	inserirMargemDeLucroNosItens() {
		if(!this.importacaoDeNota) return
		
		this.importacaoDeNota.produtos.forEach(produto => {
			produto.margemDeLucro = this.margemDeLucroGeral

			this.modificarMargemDeLucro(produto)
		})
	}

	formatarNumero(numero) {
		if(numero == null || numero == undefined) {
			return ''
		}
		return this.fixarCasasDecimais(parseFloat(numero), 2)
	}

	modificarMargemDeLucro(produto: ProdutoDaImportacao) {
		if (!produto) return;

		const parseToNumber = (valor: any): number => {
			if (!valor) return 0;
			const s = String(valor).replace(/R\$|\s/g, "").replace(/\./g, "").replace(/,/g, ".");
			const n = parseFloat(s);
			return isNaN(n) ? 0 : n;
		};

		const precoCompra = parseToNumber(produto.nota?.vUnCom);
		const margem = parseToNumber(produto.margemDeLucro);

		const precoFinal = margem === 0 
			? precoCompra 
			: precoCompra * (1 + margem / 100);

		const arredondar = (valor: number, casas = 2) => Math.round((valor + Number.EPSILON) * Math.pow(10, casas)) / Math.pow(10, casas);

		produto.precoFinalVarejo = arredondar(precoFinal, 2)
	}

	modificarPrecoDeCusto(produto: ProdutoDaImportacao) {
		if (!produto) return;

		const parseToNumber = (valor: any): number => {
			if (!valor) return 0;

			const s = String(valor).replace(/R\$|\s/g, "").replace(/\./g, "").replace(/,/g, ".");
			const n = parseFloat(s);
			return isNaN(n) ? 0 : n;
		};

		const precoCompra = parseToNumber(produto.nota?.vUnCom);
		const precoFinal = parseToNumber(produto.precoFinalVarejo);

		if (precoCompra === 0 || precoFinal === 0) {
			produto.margemDeLucro = 0;
			return;
		}

		const margem = ((precoFinal - precoCompra) / precoCompra) * 100;

		produto.margemDeLucro = (Math.round((margem + Number.EPSILON) * 100) / 100);
	}

	arredondarPreco(preco: number) {
		if (this.naoUtilizarArredondamentoDecimal) return preco

		const casasDecimais = preco - Math.floor(preco)
		
		let precoArredondado = Math.floor(preco)
		
		if (casasDecimais >= 0.50) {
			precoArredondado += this.margemArredondamentoAcima
		} else {
			precoArredondado += this.margemArredondamentoAbaixo
		}

		return precoArredondado
	}

	obterValorDoAtributo(variante, atributoEsperado) {
		const valorFiltrado =  variante.atributosVariante.filter(atributo => atributo.nome.toUpperCase() === atributoEsperado.toUpperCase())

		if (valorFiltrado.length > 0) {
			return valorFiltrado[0].valor
		}
		return 'Sem '+atributoEsperado
	}

	listarCores(produto: Produto) {
		if (!produto) return []
		if (produto.tipo === 'Com Variantes' && Array.isArray((produto as any).variantes)) {
			const cores = (produto as any).variantes
				.map(v => this.obterValorDoAtributo(v, 'Cor'))
				.filter(v => !!v)
			return Array.from(new Set(cores))
		}
		return []
	}

	listarGrades(produto: Produto) {
		if (!produto) return []
		if (produto.tipo === 'Com Variantes' && Array.isArray((produto as any).variantes)) {
			const tamanhos = (produto as any).variantes
				.map(v => this.obterValorDoAtributo(v, 'Tamanho'))
				.filter(v => !!v)
			return Array.from(new Set(tamanhos))
		}
		return []
	}

	montarGradeDoProduto() {
		this.dialogoDeSelecaoDeGradeDeProdutos.mostrar()
	}

	adicionarCoresAoProduto() {
		this.dialogoDeAdicionarCor.mostrar(this.produtoEmEdicao)
	}

	async criarVariacoesDoProdutoEmEdicao(cores, tamanhos) {
		this.produtoEmEdicao.tipo = 'Com Variantes'

		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			try {
				this.gerandoVariantes = true
				const atributos = await this.findAtributosUseCase.findAll()
				
				let atributoCor
				let atributoTamanho

				if (!atributos || atributos.length === 0){
					const cor = {id: '', nome: "Cor"}
					const tamanho = {id: '', nome: "Tamanho"}
					atributoCor = await this.findAtributosUseCase.create(cor)
					atributoTamanho = await this.findAtributosUseCase.create(tamanho)
				} else {
					atributoCor = atributos.filter(atributo => atributo.nome.toUpperCase() === 'COR')[0]
					atributoTamanho = atributos.filter(atributo => atributo.nome.toUpperCase() === 'TAMANHO')[0]
				}

				this.produtoEmEdicao.atributosProduto = []

				this.produtoEmEdicao.atributosProduto.push({
					id: '',
					atributo: atributoCor,
					valores: cores,
					descontoVarejo: 0,
				} as AtributoDoProduto)

				this.produtoEmEdicao.atributosProduto.push({
					id: '',
					atributo: atributoTamanho,
					valores: tamanhos,
					descontoVarejo: 0,
				} as AtributoDoProduto)

				const variantes = this.criarVariantesDoProduto(Object.create(this.produtoEmEdicao), this.produtoEmEdicao.atributosProduto)

				this.produtoEmEdicao.variantes = variantes
			} catch(error) {
				AlertModule.setError(error)
			} finally {
				this.gerandoVariantes = false
			}
		}
	}

	async criarVariacoesDeCorDoProdutoEmEdicao(cores: string[]) {
		this.produtoEmEdicao.tipo = 'Com Variantes'

		if (this.produtoEmEdicao.tipo === 'Com Variantes') {
			try {
				this.gerandoVariantes = true

				for (const cor of cores) {
					
					this.produtoEmEdicao.atributosProduto.filter(atributo => atributo.atributo.nome.toUpperCase() === 'COR')[0].valores.push(cor)

					const atributosTamanhos = this.produtoEmEdicao.atributosProduto.filter(atributo => atributo.atributo.nome.toUpperCase() === 'TAMANHO')
					let atributosCores = Object.values(this.produtoEmEdicao.atributosProduto.filter(atributo => atributo.atributo.nome.toUpperCase() === 'COR'))
					
					atributosCores = atributosCores.map(atributoCor => {
						atributoCor.valores = atributoCor.valores.filter(valor => cores.includes(valor))
						return atributoCor
					})

					const novasVariantes = this.criarVariantesDoProduto(this.produtoEmEdicao, [...atributosTamanhos, ...atributosCores])

					for (const variante of novasVariantes) {
						this.produtoEmEdicao.variantes.push(variante)	
					}
				}
				
			} catch(error) {
				AlertModule.setError(error)
			} finally {
				this.gerandoVariantes = false
			}
		}
	}

	removerEspacos(str) {
		return str.replace(/\s+/g, "")
	}

	criarVariantesDoProduto(
		produto: Produto,
		atributos: AtributoDoProduto[],
	) {
	
		const atributosDaVariante = atributos
			.filter(({ valores }) => valores.length)
			.map(({ id, atributo, valores }) =>
				valores.map(valor => ({
					id,
					nome: atributo.nome,
					valor,
				})),
			)
		const variacoes: Variacao[] = cartesianProduct(atributosDaVariante)
		const variantes = variacoes.map<Variante>((variacao, index) => ({
			id: '',
			ncm: null,
			cest: null,
			regraFiscal: null,
			idProdutoPai: produto.id,
			tipo: "Variante",
			tags: produto.tags,
			descricao: null,
			categoria: produto.categoria,
			urlImagens: produto.urlImagens,
			sku: produto.sku
				+ this.removerEspacos(variacao.filter(vari => vari.nome.toUpperCase() === 'TAMANHO')[0].valor.toUpperCase())
				+ this.removerEspacos(variacao.filter(vari => vari.nome.toUpperCase() === 'COR')[0].valor.toUpperCase()),
			preco: null,
			pesoLiquido: produto.pesoLiquido,
			pesoBruto: produto.pesoBruto,
			descontoVarejo: null,
			marca: produto.marca,
			nome: produto.nome,
			atributosVariante: variacao,
			temGarantia: produto.temGarantia,
			regrasFiscais: [],
			eans: [(Date.now() + index).toString()],
			unidadeDeMedida: produto.unidadeDeMedida,
			identificadores: [],
			produtoDesativado: produto.produtoDesativado,
			produtoIntegrado: produto.produtoIntegrado,
			genero: produto.genero,
			fatorDeConversao: produto.fatorDeConversao,
			unidadeDeConversao: produto.unidadeDeConversao,
			estacao: produto.estacao,
			isValePresente: false,
			skuPai: produto.skuPai,
			quantidadeImportacao: 0,
			fornecedor: produto.fornecedor,
			precoCompra: null,
			margemLucro: null,
			nomeCompleto: produto.nome + ' ' + variacao.filter(vari => vari.nome.toUpperCase() === 'COR')[0].valor + '/' + variacao.filter(vari => vari.nome.toUpperCase() === 'TAMANHO')[0].valor,
			varianteVinculada: [],
			vinculada: false,
			produtoIncompleto: false,
			familiasDoProduto: produto.familiasDoProduto,
			tipoDaOrigemDoProduto: produto.tipoDaOrigemDoProduto,
			codigoOrigemDoProduto: produto.codigoOrigemDoProduto,
		}))
		return variantes
	}

	async onReloadFinalizar() {
		if (!this.importacaoDeNota) return

		this.podeFinalizar = this.importacaoDeNota.produtos.filter(produto => produto.encontrado && produto.encontrado.tipo && produto.encontrado.tipo === 'Com Variantes').length > 0 
			&& (this.importacaoDeNota.produtos.filter(p => !p.isCamposBloqueados).length === 0)
			&& !this.importacaoDeNota.quantidadesPreenchidasCorretamente
	}

	async aplicarMarcaEmTodosProdutos(marcaSelecionada: Marca, produtoDaImportacao: ProdutoDaImportacao) {
		if (!this.importacaoDeNota) return
		if (!marcaSelecionada) return

		const primeiroProdutoSelecionavel = this.importacaoDeNota.produtos.find(produto => 
			produto.encontrado !== null && !(produto.encontrado && (produto.encontrado.id || produto.isProdutoComReferenciaCriadaNaImportacao)),
		)

		if (primeiroProdutoSelecionavel && primeiroProdutoSelecionavel.indice === produtoDaImportacao.indice) {
			if (await this.confirmarAlteracaoDasMarcas.mostrar()) {
				this.importacaoDeNota.produtos.forEach(produto => {
					if ((produto.encontrado !== null && !(produto.encontrado && (produto.encontrado.id || produto.isProdutoComReferenciaCriadaNaImportacao))) && this.importacaoDeNota) {
						produto.encontrado.marca = marcaSelecionada
					}
				})
			}
		}
	}

	regraMargemArredondamento = (v: number) => {
		if (v === null || v === undefined) return true
		return v >= 0.00 && v <= 0.99 || 'O valor deve estar entre 0.00 e 0.99'
	}

	regraDuasCasasDecimais = (v: number) => {
		if (v === null || v === undefined) return true
		const str = v.toString()
		const decimalPart = str.split('.')[1]
		return !decimalPart || decimalPart.length <= 2 || 'Máximo 2 casas decimais'
	}

	normalizarMargem(tipo: 'abaixo' | 'acima') {
		let valor = tipo === 'abaixo' ? Number(this.margemArredondamentoAbaixo) : Number(this.margemArredondamentoAcima)
		if (isNaN(valor)) valor = tipo === 'abaixo' ? 0 : 0.99
		if (valor < 0) valor = 0
		if (valor > 0.99) valor = 0.99
		valor = Math.floor(valor * 100) / 100
		valor = Number(valor.toFixed(2))
		if (tipo === 'abaixo') this.margemArredondamentoAbaixo = valor
		else this.margemArredondamentoAcima = valor
	}

	private isProdutoComVariantes(produto: Produto): produto is ProdutoComVariantes {
		return produto && produto.tipo === 'Com Variantes'
	}

	private possuiAtributosDeProduto(produto: Produto) {
		return this.isProdutoComVariantes(produto) && Array.isArray(produto.atributosProduto) && produto.atributosProduto.length > 0
	}

	isNameTooLong(name) {
		return name.length > 60;
	}

	truncatedName(name) {
		return name.length > 60 ? name.slice(0, 60) + "..." : name;
	}

	getNameStyle(name) {
		if (this.isNameTooLong(name)) {
			return { color: 'red' };
		}
		return { color: 'white' };
	}

	salvarNomeDoProduto(nomeDoProduto, item: ProdutoDaImportacao) {
		if(!this.importacaoDeNota) return

		const indice = this.importacaoDeNota.produtos.indexOf(item)

		if(nomeDoProduto.length > 60){
			item.erroNomeDeProdutoEhLongo = 'Nome excede 60 caracteres'
			return	
		} else if(nomeDoProduto.length < 1){
			item.erroNomeDeProdutoEhLongo = 'Nome não pode ser vazio'
			return	
		}else{
			item.erroNomeDeProdutoEhLongo = ''
		}

		this.importacaoDeNota.produtos[indice].nota.xProd = nomeDoProduto
	}

	@Watch('importacaoDeNota.produtos', { deep: true })
	validarNomeDeProduto(){
		if(!this.importacaoDeNota) return

		this.importacaoDeNota.produtos.forEach(produto => {
			if(produto.nota.xProd.length > 60){
				produto.isProdutoPossuiNomeLongo = true
				produto.isCamposBloqueados = false
				produto.erroNomeDeProdutoEhLongo = 'Nome excede 60 caracteres'
			} else if(produto.nota.xProd.length < 1){
				produto.isProdutoPossuiNomeLongo = true
				produto.isCamposBloqueados = false
				produto.erroNomeDeProdutoEhLongo = 'Nome não pode ser vazio'
			}else{
				produto.erroNomeDeProdutoEhLongo = ''
				produto.isProdutoPossuiNomeLongo = false
			}		
		})
	}

	validarCProdDuplicados() {
		if (!this.importacaoDeNota) return;

		const todosCProds: string[] = [];
		this.importacaoDeNota.produtos.forEach(produto => {
			const cProd = produto.nota.cProd;
			if (cProd && cProd.trim() !== '') {
				todosCProds.push(cProd.trim());
			}
		});

		const contagemCProds: Record<string, number> = {};
		todosCProds.forEach(cProd => {
			contagemCProds[cProd] = (contagemCProds[cProd] || 0) + 1;
		});

		const cProdsDuplicados = new Set(
			Object.entries(contagemCProds)
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				.filter(([_, count]) => count > 1)
				.map(([cProd]) => cProd),
		);

		this.importacaoDeNota.produtos.forEach(produto => {
			const cProd = produto.nota.cProd;
			if (cProd && cProdsDuplicados.has(cProd.trim())) {
				produto.isPossuiCProdDuplicado = true;
			} else {
				produto.isPossuiCProdDuplicado = false;
			}
		});
	}

	alternarBloqueioCampos(item: ProdutoDaImportacao) {
		if (!this.importacaoDeNota) return
		const indice = typeof item.indice === 'number' ? item.indice : this.importacaoDeNota.produtos.indexOf(item)
		const atualizado = { ...this.importacaoDeNota.produtos[indice], isCamposBloqueados: false, criouRelacaoDeProdutoPai: false }
		this.$set(this.importacaoDeNota.produtos, indice, atualizado)
		this.tableRerenderKey++
		this.$nextTick(() => {
			this.form && this.form.validate && this.form.validate()
			this.$forceUpdate()
		})
	}

	confirmarNomeECodigo(item: ProdutoDaImportacao) {
		if (!this.importacaoDeNota) return

		this.validarNomeDeProduto()
		this.validarCProdDuplicados()

		if (item.encontrado && item.encontrado.tipo === 'Com Variantes' && !item.encontrado.atributosProduto) {
			AlertModule.setError('Necessario adicionar grade no item')
			return
		}

		if (Number(item.quantidadeInformada) !== Number(item.nota.qCom)) {
			AlertModule.setError(`Item com quantidade incorreta: ${item.nota.cProd}`)
			return
		}

		const nomeTexto = item.nota?.xProd ? String(item.nota.xProd) : ''
		const codigoTexto = item.nota?.cProd ? String(item.nota.cProd) : ''
		const nomeValido = nomeTexto.trim() !== '' && !item.isProdutoPossuiNomeLongo && nomeTexto.length <= 60
		const codigoValido = codigoTexto.trim() !== '' && !item.isPossuiCProdDuplicado
		const tipoEncontrado = item.encontrado && item.encontrado.tipo

		if (!(nomeValido && codigoValido) && tipoEncontrado !== 'Padrão') {
			AlertModule.setError('Nome e código devem estar válidos para confirmar')
			return
		}

		const indice = typeof item.indice === 'number'
			? item.indice
			: this.importacaoDeNota.produtos.indexOf(item)

		if (indice < 0) return

		const atualizado = {
			...this.importacaoDeNota.produtos[indice],
			isNomeECodigoConfirmados: true,
			isCamposBloqueados: true,
		}

		this.$set(this.importacaoDeNota.produtos, indice, atualizado)
	}

	async alternarVinculoDoItem(item: ProdutoDaImportacao) {
		if (!this.importacaoDeNota) return
		const indice = typeof item.indice === 'number' ? item.indice : this.importacaoDeNota.produtos.indexOf(item)
		this.$set(this.carregandoVinculoDeProduto, indice, true)

		try {
			if (item.encontrado && (item.encontrado.id || item.isProdutoComReferenciaCriadaNaImportacao)) {
				const desvincularProduto = !!(await this.confirmacaoDeDesvincularProduto.mostrar());
				if (desvincularProduto) {
					item.encontrado.id = ''
					item.encontrado.marca = null
					item.encontrado.genero = null
					item.encontrado.quantidadeImportacao = null
					item.encontrado.tags = []
					item.encontrado.urlImagens = []
					item.encontrado.categoria = null
					item.encontrado.estacao = null
				}

				if(item.encontrado.tipo === 'Com Variantes' && item.encontrado.variantes){
					item.encontrado.variantes = []
				}

				this.$set(this.importacaoDeNota.produtos, indice, { ...item })
				localStorage.setItem(IMPORTACAO_DE_NOTA, JSON.stringify(this.importacaoDeNota))

				return
			}

			this.dialogoDeBuscarVinculoDeProdutos.mostrar(indice, item.nota.xProd, this.podeCriarProduto);

		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.$set(this.carregandoVinculoDeProduto, indice, false)
		}
	}

	async fazerVinculoDosProdutos(sku, indiceDoProduto){
		const produto = await this.finalizarImportacaoDeNotaDoFornecedorUseCase.buscarProdutosParaRelacionar(sku, 'sku');

		this.onProdutosSelecionados(produto, indiceDoProduto)
	}	

	formatarMensagemDeDesvincularProduto() {
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, o produto será desvinculado
				</div>
			`
	}

	formatarMensagemDeVincularVariante(){
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, não será possivel desvincular
				</div>
			`
	}

	formatarMensagemDeReplicarAtributos(){
		return `
				<div><h2 class="formatarAviso">Aviso!</h2></div>
				<div class="mt-4">
					Se confirmar, o(s) atributo(s) adicionado(s) serão replicado(s) para todos os produtos!
					A ação é irreversivel
				</div>
			`
	}

	cancelEditing(item) {
		if (item.originalValue !== undefined) {
			item.nota.xProd = item.originalValue;
			delete item.originalValue;
		}
		
		this.$set(item, 'isEditingName', false);
	}

	onProdutosSelecionados(produtos: Produto[], indice: number) {
		if(!this.importacaoDeNota) return

		const jaPossuiVinculo = this.importacaoDeNota.produtos.filter(p => p.encontrado && 
			p.encontrado.id !== "" && p.encontrado.id && p.encontrado.id === produtos[0].id || 
				(p.encontrado?.id && p.encontrado?.sku === produtos[0].sku)).length > 0

		if(jaPossuiVinculo){
			AlertModule.setError('Produto já possui vínculo, desvincule antes de selecionar outro produto')
			return
		}
		
		const produtoSelecionado = produtos[0]
		if (!produtoSelecionado) return

		const itemOriginal = this.produtosOriginal.find(produto => produto.indice === indice)

		if(itemOriginal){
			itemOriginal.encontrado = produtoSelecionado
			this.importacaoDeNota.produtos[indice] = itemOriginal
		} else{
			this.importacaoDeNota.produtos[indice].encontrado = produtoSelecionado
		}
		
		this.$set(this.importacaoDeNota.produtos, indice, { ...this.importacaoDeNota.produtos[indice] })
		localStorage.setItem(IMPORTACAO_DE_NOTA, JSON.stringify(this.importacaoDeNota))
	}

	onProdutosAgrupados(novaQtde: string, indice: number, itensAhRemover: number[], produtosAgrupados: ProdutoDaImportacao[]){
		if(!this.importacaoDeNota) return

		this.importacaoDeNota.produtos[indice].nota.qCom = novaQtde
		this.importacaoDeNota.produtos[indice].contemAgrupamentoDeItens = true

		this.importacaoDeNota.produtos[indice].produtosAgrupados = [
			...this.importacaoDeNota.produtos[indice].produtosAgrupados,
			...produtosAgrupados,
		];

		this.produtosQueForamAgrupados = [
			...this.produtosQueForamAgrupados,
			...produtosAgrupados,
		]
		
		this.importacaoDeNota.produtos.forEach(p => {
			if (itensAhRemover.includes(p.nota.nItem)) {
				p.isProdutoEstaAgrupado = true
			}
		})

		this.importacaoDeNota.produtos = [...this.importacaoDeNota.produtos]
	}

	onDesagruparProdutos(itensParaDesagrupar, indiceDoItemBase: number){
		if(!this.importacaoDeNota) return

		this.importacaoDeNota.produtos.forEach(p => {
			if (itensParaDesagrupar.some(item => item.indice === p.indice)) {
				p.isProdutoEstaAgrupado = false
			}
		})

		this.importacaoDeNota.produtos[indiceDoItemBase].produtosAgrupados =
			this.importacaoDeNota.produtos[indiceDoItemBase].produtosAgrupados.filter(
				(p: ProdutoDaImportacao) =>
					!itensParaDesagrupar.some(
						(remover: ProdutoDaImportacao) => remover.nota.nItem === p.nota.nItem,
					),
			);

		if(this.importacaoDeNota.produtos[indiceDoItemBase].produtosAgrupados.length < 1){
			this.importacaoDeNota.produtos[indiceDoItemBase].contemAgrupamentoDeItens = false
		}	

		const somaDasQuantidadesParaRemover = itensParaDesagrupar.reduce(
			(total, p) => total + Number(p.nota.qCom),
			0,
		)

		this.importacaoDeNota.produtos[indiceDoItemBase].nota.qCom = (Number(this.importacaoDeNota.produtos[indiceDoItemBase].nota.qCom) - somaDasQuantidadesParaRemover).toString();
		this.importacaoDeNota.produtos = [...this.importacaoDeNota.produtos]
	}

	desagruparItens(item){
		if(!this.importacaoDeNota) return

		this.dialogoDeAgruparItensDaImportacao.mostrarDesagrupamento(item, this.importacaoDeNota.produtos[item.indice].produtosAgrupados)
	}

	@Watch('importacaoDeNota')
	get itensConfirmados(){
		return this.importacaoDeNota?.produtos.filter(produto => produto.isNomeECodigoConfirmados && produto.isCamposBloqueados && !produto.isProdutoEstaAgrupado).length
	}

	@Watch('importacaoDeNota')
	get itensPendentes(){
		if (!this.importacaoDeNota?.produtos) return 0

		if(this.importacaoDeNota?.isNecessarioDetalharOsItens){
			return this.importacaoDeNota?.produtos.filter(produto => !(produto.isCamposBloqueados) && !(produto.erroNomeDeProdutoEhLongo || produto.erroReferenciaDeProduto) && !produto.isProdutoEstaAgrupado).length
		}else{			
			return (
				Math.max(0, Number(Number(this.importacaoDeNota.produtos.filter(produto => !(produto.isCamposBloqueados)).length) - Number(this.itensComErro)))
			)
		}
	}

	@Watch('importacaoDeNota')
	get itensComErro() {
		if (!this.importacaoDeNota?.produtos) return 0

		return this.importacaoDeNota.produtos.filter(produto =>
			produto.isProdutoPossuiNomeLongo === true ||
			produto.isPossuiCProdDuplicado === true &&
			!(produto.encontrado && produto.encontrado.id),
		).length
	}

	get formatarMensagemDeFluxoNaImportacaoDeNotas(){
		const imagemSrc = '/imgs/dicaAgrupadoPorProdutoPai.png'
		const configuracaoImagem = {
			src: imagemSrc,
			larguraMaxima: '750px',
			alturaMaxima: '750px',
		}
				
		return `
			<img 
				src="${configuracaoImagem.src}" 
				style="max-width: ${configuracaoImagem.larguraMaxima}; max-height: ${configuracaoImagem.alturaMaxima};"
			>
		`
	}

	get formatarMensagemDeFluxoNaImportacaoDeNotasSecundaria(){
		const imagemSrc = '/imgs/dicaAgrupadoPorVariante.png'
		const configuracaoImagem = {
			src: imagemSrc,
			larguraMaxima: '750px',
			alturaMaxima: '750px',
		}
				
		return `
			<img 
				src="${configuracaoImagem.src}" 
				style="max-width: ${configuracaoImagem.larguraMaxima}; max-height: ${configuracaoImagem.alturaMaxima};"
			>
		`
	}

	get modoNoturno(){
		return AppStore.modoNoturno
	}

	agruparProdutos(item: ProdutoDaImportacao){
		if(!this.importacaoDeNota) return

		this.dialogoDeAgruparItensDaImportacao.mostrar(item, this.importacaoDeNota?.produtos)
	}

	mensagemDeErroNoProduto(nomeIsLong: boolean, codEhDuplicado: boolean) {
		return nomeIsLong && codEhDuplicado
			? 'Nome do Produto é muito longo e Código está duplicado'
			: nomeIsLong
				? 'Nome do Produto é muito longo'
				: codEhDuplicado
					? 'Código está duplicado'
					: '';
	}

	ajustarQuantidade(variante, item, variantes) {
		const qtdeTotal = Number(item.nota.qCom);
		
		if (!variante.quantidadeImportacao || variante.quantidadeImportacao < 1) {
			variante.quantidadeImportacao = 0
		}

		if (!Number.isInteger(variante.quantidadeImportacao)) {
			variante.quantidadeImportacao = 0
			AlertModule.setError('Quantidade precisa ser um numero inteiro')
		}		const qtdeJaInserida = variantes.reduce((soma, v) => soma + (Number(v.quantidadeImportacao) || 0), 0);

		if (qtdeJaInserida > qtdeTotal) {
			variante.quantidadeImportacao = 0
			AlertModule.setError('Quantidade informada maior que a comprada')
		}

		item.quantidadeInformada = variantes.reduce((soma, v) => soma + (Number(v.quantidadeImportacao) || 0), 0);
		
		this.$forceUpdate();
	}

	confirmarTodosOsItens(){
		if(!this.importacaoDeNota) return

		this.importacaoDeNota?.produtos.forEach(p => {
			this.confirmarNomeECodigo(p)
		})
	}

	bloquearCaracteresEspeciais(event) {
		if (event.key === '.' || event.key === ',') {
			event.preventDefault();
		}
	}

	abrirProcessoDeItensAbertoPorVariante(produtosMontados: ProdutoDaImportacao[], variante: Variante[] ){
		if(!this.importacaoDeNota) return

		this.importacaoDeNota.produtos = produtosMontados
		this.variantesDaImportacao = variante
		localStorage.setItem(IMPORTACAO_DE_NOTA, JSON.stringify(this.importacaoDeNota))
		localStorage.setItem(VARIANTE_DA_IMPORTACAO, JSON.stringify(this.variantesDaImportacao))
		this.mostrarConfimacao()
	}

	adicionarCorPorVarianteJaExistente(produtoEmEdicao): boolean{
		return (this.importacaoDeNota && 
			this.importacaoDeNota.lojaDestinoDaImportacao && 
			this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja && 
			this.importacaoDeNota.lojaDestinoDaImportacao.configuracaoDaLoja.criarProdutoImportacaoEntrada &&
			produtoEmEdicao.descricao === "Produto Criado na Importação" ? false : true)
	}

	getVariantesParaSelecionar(produtoEmEdicao){
		if(!this.variantesDaImportacao) return []
		if(this.produtoEmEdicao.tipo !== 'Com Variantes') return

		const nomesJaUsados = this.produtoEmEdicao.variantes.map(v => v.nome)

		return this.variantesDaImportacao.filter(p => p.idProdutoPai === produtoEmEdicao.id && produtoEmEdicao.tipo === 'Com Variantes')
			.map(p => p.nome)
			.filter(nome => !!nome && !nomesJaUsados.includes(nome))
	}

	abrirDialogoDeVincularVariantesEmItensDaNota(){
		this.prepararVariantesParaVinculacao()
		if(this.variantesDaNotaParaVincular.filter(v => v.vinculada).length === this.variantesDaNotaParaVincular.length && 
			(this.produtoEmEdicao.tipo === 'Com Variantes' && this.produtoEmEdicao.variantes.filter(v => v.varianteVinculada).length === 0)){

			this.variantesDaNotaParaVincular.forEach(v => {
				v.vinculada = false;
			})
		}
		this.mostrarDialogoDeVincularVariantes = true
	}

	prepararVariantesParaVinculacao() {
		if(this.produtoEmEdicao.tipo !== 'Com Variantes') return
		this.limparSelecaoPorClique()

		if (this.variantesDaImportacao) {
			this.variantesDaNotaParaVincular = this.variantesDaImportacao
				.filter(variante => variante.skuPai === this.produtoEmEdicao.sku)
				.map(variante => ({
					...variante,
				}))
		}
	}

	iniciarDrag(event: DragEvent, variante: any, tipo: string) {
		if (tipo === 'nota') {
			this.varianteSendoArrastada = variante
			variante.dragging = true
			if (event.dataTransfer) {
				event.dataTransfer.effectAllowed = 'move'
				event.dataTransfer.setData('text/plain', JSON.stringify(variante))
			}
		}
	}

	finalizarDrag() {
		if (this.varianteSendoArrastada) {
			this.varianteSendoArrastada.dragging = false
			this.varianteSendoArrastada = null
		}
		this.isDraggingOverNota = false
		this.isDraggingOverGrade = false
		this.hoveredVariante = null
	}

	permitirDrop(event: DragEvent) {
		event.preventDefault()
		if (event.dataTransfer) {
			event.dataTransfer.dropEffect = 'move'
		}
	}

	processarDrop(event: DragEvent, varianteGrade: any) {
		event.preventDefault()
		
		if (!this.varianteSendoArrastada) return

		if (this.varianteSendoArrastada.vinculada) {
			AlertModule.setError('Esta variante já está vinculada a outra grade')
			return
		}

		if(varianteGrade.varianteVinculada && varianteGrade.varianteVinculada.nome){
			AlertModule.setError("Produto já está vinculado!")
			return
		}

		varianteGrade.varianteVinculada = this.varianteSendoArrastada
		this.varianteSendoArrastada.vinculada = true

		this.vinculacoes.push({
			varianteNota: this.varianteSendoArrastada,
			varianteGrade: varianteGrade,
		})

		varianteGrade.quantidadeImportacao = this.varianteSendoArrastada.quantidadeImportacao

		this.$nextTick(() => {
			AlertModule.setSuccess(`Variante "${this.varianteSendoArrastada.nome}" vinculada com sucesso!`)
		})

		this.finalizarDrag()
	}

	cancelarVinculacao() {
		this.mostrarDialogoDeVincularVariantes = false
		this.limparEstadoDragAndDrop()
		this.limparSelecaoPorClique()
	}

	limparVinculacoes(varianteNota) {
		this.vinculacoes.forEach(item => {
			if (item.varianteNota && item.varianteNota.nome === varianteNota.nome) {
				item.varianteNota.vinculada = false
				item.varianteNota.dragging = false
				item.varianteGrade.varianteVinculada = null
				item.varianteGrade.quantidadeImportacao = 0
			}
		})

		this.variantesDaNotaParaVincular.forEach(item => {
			if (item.nome === varianteNota.nome) {
				item.varianteVinculada = null
				item.vinculada = false
			}
		})

		this.vinculacoes = this.vinculacoes.filter(item =>
			!(item.varianteNota && item.varianteNota.nome === varianteNota.nome),
		)

		this.modoSelecaoPorClique = false
		this.varianteSelecionadaParaClique = []
	}


	limparTodasVinculacoes() {
		this.vinculacoes.forEach(({ varianteNota, varianteGrade }) => {
			varianteNota.vinculada = false
			varianteGrade.varianteVinculada = null
			varianteGrade.quantidadeImportacao = 0
		})

		this.vinculacoes = []
		this.finalizarDrag()
	}

	async salvarVinculacoes() {
		if (this.vinculacoes.length === 0) {
			AlertModule.setError('Nenhuma vinculação foi realizada')
			return
		}

		const vincularProduto = !!(await this.confirmacaoDeVincularVariantes.mostrar());

		if (vincularProduto) {
			try {

				const vincularProduto = !!(await this.confirmacaoDeUtilizarDadosDaNota.mostrar());

				this.vinculacoes.forEach(({ varianteNota, varianteGrade }) => {
					
					if(vincularProduto){
						varianteGrade.eans = varianteNota.eans || []
					}
					
					varianteGrade.quantidadeImportacao = varianteNota.quantidadeImportacao
					
					varianteGrade.varianteVinculada = varianteNota
					
					if (this.variantesDaImportacao) {
						const varianteOriginal = this.variantesDaImportacao.find(v => v.nome === varianteNota.nome)
						if (varianteOriginal) {
							varianteOriginal.vinculada = true
						}
					}

				})

				this.tableRerenderKey++
				
				AlertModule.setSuccess(`${this.vinculacoes.length} vinculações salvas com sucesso!`)
				this.mostrarDialogoDeVincularVariantes = false
				this.mostrarDialogoDeEdicaoDeProduto = false
				this.carregando = false
				this.salvandoEdicaoDeProduto = false
				this.limparEstadoDragAndDrop()
				this.salvarProduto()
				this.$forceUpdate();
			} catch (error) {
				AlertModule.setError('Erro ao salvar vinculações: ' + error)
			}
		}
	}

	limparEstadoDragAndDrop() {
		this.isDraggingOverNota = false
		this.isDraggingOverGrade = false
		this.hoveredVariante = null
		this.varianteSendoArrastada = null
		this.vinculacoes = []
		this.variantesDaNotaParaVincular = []
		this.limparSelecaoPorClique()
	}

	selecionarVarianteNota(variante: any) {
		if (variante.vinculada) {
			AlertModule.setError('Esta variante já está vinculada')
			return
		}

		if (this.varianteSelecionadaParaClique === variante) {
			this.varianteSelecionadaParaClique = []
			this.modoSelecaoPorClique = false
			this.varianteGradeSelecionada = []
		} else {
			this.varianteSelecionadaParaClique = variante
			this.modoSelecaoPorClique = true
			this.varianteGradeSelecionada = []
			AlertModule.setInfo(`Variante "${variante.nome}" selecionada. Agora clique em uma variante da grade para vincular.`)
		}
	}

	selecionarVarianteGrade(varianteGrade: any) {
		if (this.modoSelecaoPorClique && this.varianteSelecionadaParaClique) {
			this.vincularVariantesPorClique(this.varianteSelecionadaParaClique, varianteGrade)
		} else if(!varianteGrade.varianteVinculada && !varianteGrade.varianteVinculada.nome){
			this.varianteGradeSelecionada = varianteGrade
			if (!this.modoSelecaoPorClique) {
				AlertModule.setInfo('Selecione primeiro uma variante da nota para vincular.')
			}
		} else {
			AlertModule.setError('Produto já está vinculado')
		}
	}

	vincularVariantesPorClique(varianteNota: any, varianteGrade: any) {
		if(varianteGrade.varianteVinculada && varianteGrade.varianteVinculada.nome){
			AlertModule.setError("Produto já está vinculado!")
			return
		}

		try {
			varianteGrade.varianteVinculada = varianteNota
			varianteNota.vinculada = true

			this.vinculacoes.push({
				varianteNota: varianteNota,
				varianteGrade: varianteGrade,
			})

			varianteGrade.quantidadeImportacao = varianteNota.quantidadeImportacao

			this.limparSelecaoPorClique()

			AlertModule.setSuccess(`Variante "${varianteNota.nome}" vinculada com sucesso!`)

		} catch (error) {
			AlertModule.setError('Erro ao vincular variantes: ' + error)
		}
	}

	limparSelecaoPorClique() {
		this.varianteSelecionadaParaClique = []
		this.varianteGradeSelecionada = []
		this.modoSelecaoPorClique = false
	}

	ehProdutoCriadoNaImportacao(produto){
		return produto && 
			!!produto.id && 
			(!this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === produto.sku)?.isProdutoComReferenciaCriadaNaImportacao && 
				(this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === produto.sku)?.encontrado?.id || 
					this.importacaoDeNota?.produtos.find(p => p.encontrado?.sku === produto.sku)?.encontrado?.descricao === 'Produto Criado na Importação'))
	}

	async replicarAtributos(){
		const replicarAtributos = !!(await this.confirmacaoDeReplicarAtributos.mostrar());
		if(replicarAtributos){
			const marcaAtributo = this.produtoEmEdicao.marca;
			const estacao = this.produtoEmEdicao.estacao;
			const tags = this.produtoEmEdicao.tags;
			const genero = this.produtoEmEdicao.genero;
			const categoria = this.produtoEmEdicao.categoria;
			
			this.importacaoDeNota?.produtos.forEach(produto => {
				console.log(produto)
				if(produto.encontrado){
					produto.encontrado.marca = marcaAtributo
					produto.encontrado.estacao = estacao;
					produto.encontrado.tags = tags;
					produto.encontrado.genero = genero;
					produto.encontrado.categoria = categoria;
				}
			})
		}
	}

	async replicarMarca() {
		const confirmar = !!(await this.confirmacaoDeReplicarAtributos.mostrar());
		if (!confirmar) return;

		this.importacaoDeNota?.produtos
			.filter(p => !this.ehProdutoCriadoNaImportacao(p))
			.forEach(produto => {
				if (produto.encontrado) {
					produto.encontrado.marca = this.produtoEmEdicao.marca;
				}
			});
	}

	async replicarGenero() {
		const confirmar = !!(await this.confirmacaoDeReplicarAtributos.mostrar());
		if (!confirmar) return;

		this.importacaoDeNota?.produtos
			.filter(p => !this.ehProdutoCriadoNaImportacao(p))
			.forEach(produto => {
				if (produto.encontrado) {
					produto.encontrado.genero = this.produtoEmEdicao.genero;
				}
			});
	}

	async replicarEstacao() {
		const confirmar = !!(await this.confirmacaoDeReplicarAtributos.mostrar());
		if (!confirmar) return;

		this.importacaoDeNota?.produtos
			.filter(p => !this.ehProdutoCriadoNaImportacao(p))
			.forEach(produto => {
				if (produto.encontrado) {
					produto.encontrado.estacao = this.produtoEmEdicao.estacao;
				}
			});
	}

	async replicarCategoria() {
		const confirmar = !!(await this.confirmacaoDeReplicarAtributos.mostrar());
		if (!confirmar) return;

		this.importacaoDeNota?.produtos
			.filter(p => !this.ehProdutoCriadoNaImportacao(p))
			.forEach(produto => {
				if (produto.encontrado) {
					produto.encontrado.categoria = this.produtoEmEdicao.categoria;
				}
			});
	}

	async replicarTags() {
		const confirmar = !!(await this.confirmacaoDeReplicarAtributos.mostrar());
		if (!confirmar) return;

		this.importacaoDeNota?.produtos
			.filter(p => !this.ehProdutoCriadoNaImportacao(p))
			.forEach(produto => {
				if (produto.encontrado) {
					produto.encontrado.tags = this.produtoEmEdicao.tags;
				}
			});
	}

	get produtosFinalizados() {
		if(!this.importacaoDeNota) return [];

		return this.importacaoDeNota.produtos
			.filter((p): p is typeof p & { encontrado: ProdutoComVariantes } =>
				!!p.isCamposBloqueados && !!p.encontrado && p.encontrado.tipo === 'Com Variantes',
			)
			.flatMap(p => 
				p.encontrado.variantes
					.filter(v => v.quantidadeImportacao && v.quantidadeImportacao > 0)
					.map(v => ({
						...v,
						precoCompra: p.precoFinalVarejo,
					})),
			);
	}
}

